import { LicenseRimmSubEntitySelectField as RimmSubEntitySelectField } from './LicenseRimmSubEntitySelectField';
import { LicenseAdditionalFieldSelect as AdditionalFieldSelect } from './LicenseAdditionalFieldSelect';
import { LicenseRimmEntitySelectField as RimmSelectField } from './LicenseRimmEntitySelectField';
import { LicenseFieldController as Controller } from './LicenseFieldController';
import { LicenseSelectField as SelectField } from './LicenseSelectField';
import { LicenseTextField as TextField } from './LicenseTextField';
import { LicenseDateField as DateField } from './LicenseDateField';
import { LicenseSwitcher as Switcher } from './LicenseSwitcher';
import { LicenseCheckbox as Checkbox } from './LicenseCheckbox';

export const LicenseField = {
  TextField,
  SelectField,
  DateField,
  Controller,
  RimmSelectField,
  RimmSubEntitySelectField,
  Switcher,
  Checkbox,
  AdditionalFieldSelect,
};
